import DocTypes from '@/assets/enums/invoicing/DocTypes'
import {
  base_order_infos_dossier,
  base_order_funeral,
  base_order_remain
} from '@/assets/settings/EventsOrder'
import type { MetadataGetters } from './types'

export default {
  getRolesMetadata(state) {
    return state.initialMetadata.models.roles
  },
  getUsersMetadata(state) {
    return state.initialMetadata.models.users
  },
  getUserMetadata: (state) => (id) => {
    return state.initialMetadata.models.users.find(
      (user: { id: any }) => user.id === id
    )
  },
  getAllUsersMetadata: (state) => {
    return state.initialMetadata.models.all_users ?? []
  },
  getAllUserMetadata: (state) => (id) => {
    return state.initialMetadata.models.all_users.find((user) => user.id === id)
  },
  getMaterialResourceMetadata: (state) => (id) => {
    return state.initialMetadata.models.material_resources.find(
      (material_resource) => material_resource.id === id
    )
  },
  getMaterialResourcesMetadata: (state) => {
    return state.initialMetadata.models.material_resources ?? []
  },
  getCompaniesMetadata(state) {
    return state.initialMetadata.models.companies ?? []
  },
  getFuneralHomesMetadata(state) {
    return state.initialMetadata.models.funeralHomes ?? []
  },
  getSitesMetadata(state) {
    return state.initialMetadata.models.sites
  },
  getSiteMetadata: (state) => (id) => {
    return state.initialMetadata.models.sites.find((site) => site.id === id)
  },
  getRoomsMetadata(state) {
    return state.initialMetadata.models.rooms_by_funerarium_id
  },
  getLocationsMetadata(state) {
    return state.initialMetadata.models.locations ?? []
  },
  getLocationMetadata: (state) => (id) => {
    return state.initialMetadata.models.locations.find(
      (location) => location.id === id
    )
  },
  getSuppliersMetadata(state) {
    return state.initialMetadata.models.suppliers ?? []
  },
  getFuneralHomeMetadata: (state) => (id) => {
    return state.initialMetadata.models.funeralHomes.find(
      (funeral_home) => funeral_home.id === id
    )
  },
  getCompanyMetadata: (state) => (id) => {
    return state.initialMetadata.models.companies.find(
      (company) => company.id === id
    )
  },
  getDossierNumberingsMetadata: (state) => {
    return state.initialMetadata.models.dossier_numberings ?? []
  },
  getInvoicingCategoriesMetadata: (state) => {
    return state.initialMetadata.models.invoicing_categories ?? []
  },
  getInvoiceStylingTypesMetadata: (state) => {
    return state.initialMetadata.enums.invoice_styling_types ?? []
  },

  getDossierStatusMetadata(state) {
    return state.initialMetadata.enums.dossier_status ?? []
  },
  getCivilityMetadata(state) {
    return state.initialMetadata.enums.civilities ?? []
  },
  getGenderMetadata(state) {
    return state.initialMetadata.enums.genders ?? []
  },
  getTransfertTimeTypeMetadata(state) {
    return state.initialMetadata.enums.transfer_hourly_types ?? []
  },
  getMaritalStatusesMetadata(state) {
    return state.initialMetadata.enums.maritalStatuses ?? []
  },
  getLifeSituationsMetadata(state) {
    return state.initialMetadata.enums.lifeSituations ?? []
  },
  getDiplomesMetadata(state) {
    return state.initialMetadata.enums.diplomes ?? []
  },

  getRelationshipsMetadata(state) {
    return state.initialMetadata.enums.relationship ?? []
  },
  getRelationshipMetadata: (state) => (id) => {
    return state.initialMetadata.enums.relationship.find(
      (relationship) => relationship.id === id
    )
  },
  getRelationshipFamilyMetadata(state) {
    return state.initialMetadata.enums.relationship_family ?? []
  },
  getRelationshipMaritalStatusMetadata(state) {
    return state.initialMetadata.enums.relationship_marital_status ?? []
  },
  // getContactRolesMetadata(state) {
  //   return state.initialMetadata.enums.contactRoles ?? []
  // },
  getCountriesMetadata(state) {
    return state.initialMetadata.enums.countries ?? []
  },
  getLanguagesMetadata(state) {
    return state.initialMetadata.enums.languages ?? []
  },
  getOccupationsMetadata(state) {
    return state.initialMetadata.enums.occupations ?? []
  },
  getSocialStatesMetadata(state) {
    return state.initialMetadata.enums.social_states ?? []
  },
  getAssignmentStatusMetadata(state) {
    return state.initialMetadata.enums.assignement_status ?? []
  },
  getAssignedPersonFunctionsMetadata(state) {
    return state.initialMetadata.models.list_items.users_event_functions ?? []
  },
  getContactRolesMetadata(state) {
    return state.initialMetadata.models.list_items.contact_roles ?? []
  },
  getItemQuantityUnitsMetadata(state) {
    return state.initialMetadata.models.list_items.item_quantity_units ?? []
  },
  getQuantityDisplayModesMetadata(state) {
    return state.initialMetadata.enums.quantity_display_modes ?? []
  },
  getContactsMetadata(state) {
    return state.initialMetadata.models.contacts ?? []
  },
  getTypesLocationMetadata(state) {
    return state.initialMetadata.enums.types_location ?? []
  },

  getInitialMetadata(state) {
    return state.initialMetadata
  },
  getOpenModalVersionNote(state) {
    return state.openModalVersionNote
  },
  getMetadataLoaded(state) {
    return state.loaded
  },
  getMetadataItemCategoryGroups(state) {
    return state.initialMetadata.enums.item_category_group
  },
  getMetadataInvoicingCategories(state) {
    return state.initialMetadata.models.invoicing_categories
  },
  getMetadataCategoriesNormalized(state) {
    return state.initialMetadata.enums.french_normalized_quotes_categories
  },
  getMetadataCategoriesNormalizedNewList(state) {
    return state.initialMetadata.enums.french_normalized_2025_quotes_categories
  },
  getMetadataNormalizedItemTypes(state) {
    return state.initialMetadata.enums.french_normalized_item_types
  },
  getMetadataNormalizedItemTypesNewList(state) {
    return state.initialMetadata.enums.french_normalized_2025_item_types
  },
  getMetadataMaterialResourcesTypes(state) {
    return state.initialMetadata.models.material_resource_types
  },
  getMetadataTaskTypes(state) {
    return state.initialMetadata.models.list_items.task_types
  },
  getMetadataItemCategories(state) {
    return state.initialMetadata.models.item_categories
  },
  getMetadataItemCategoriesSelect(state) {
    return state.initialMetadata.models.item_categories_select
  },
  getMetadataItemCategoriesGroupByParent(state) {
    return state.initialMetadata.models.item_categories_group_by_parent
  },
  getMetadataItemCategoriesGroupByParentAndGroup(state) {
    return state.initialMetadata.models
      .item_categories_group_by_parent_and_group
  },
  getMetadataTasks(state) {
    return state.initialMetadata.models.tasks
  },
  getMetadataTaskCategories(state) {
    return state.initialMetadata.models.list_items.task_categories
  },
  getMetadataTaskStatuses(state) {
    return state.initialMetadata?.enums?.task_status
  },
  getMetadataAvailabilityReasons(state) {
    return state.initialMetadata?.enums?.availability_reasons
  },
  getMetadataDossierTypes(state) {
    const defaultTypes = state.initialMetadata?.settings?.dossier_types ?? []
    return (
      state.initialMetadata?.enums?.types?.filter((type) =>
        defaultTypes?.includes(type.id)
      ) ?? []
    )
  },
  getMetadataAvailableModules(state) {
    return state.initialMetadata?.enums?.available_modules ?? []
  },
  getMetadataDossierStatuses(state) {
    return state.initialMetadata?.enums?.default_dossier_status ?? []
  },
  getMetadataStockStatuses(state) {
    return state.initialMetadata?.enums?.stock_statuses ?? []
  },
  getMetadataItemStockOrderStatuses(state) {
    return state.initialMetadata?.enums?.item_stock_order_statuses ?? []
  },
  getMetadataVigilanceStatuses(state) {
    return state.initialMetadata?.enums?.vigilance_statuses ?? []
  },
  getMetadataItemOrderModes(state) {
    return state.initialMetadata?.enums?.item_order_modes ?? []
  },
  getMetadataSupplierOrderStatuses(state) {
    return state.initialMetadata?.enums?.supplier_order_status ?? []
  },
  getMetadataIcons(state) {
    return state.initialMetadata?.enums?.icons ?? []
  },
  getMainKey(state) {
    return state.mainKey
  },
  getLanguages(state) {
    return state.initialMetadata.enums.languages
  },
  getDocumentVariables(state) {
    return state.initialMetadata.enums.doc_variables ?? []
  },
  getEditorDocumentVariables(state) {
    return (state.initialMetadata.enums.doc_variables ?? []).filter((group) =>
      group.availabilities?.includes('editor')
    )
  },
  getListDocumentVariables(state) {
    return (state.initialMetadata.enums.doc_variables ?? []).filter((group) =>
      group.availabilities?.includes('list')
    )
  },
  getMessageDocumentVariables(state) {
    return (state.initialMetadata.enums.doc_variables ?? []).filter((group) =>
      group.availabilities?.includes('message')
    )
  },
  getMessageGroupsMetadata(state) {
    return state.initialMetadata.enums.message_groups ?? []
  },
  getMessageTypesMetadata(state) {
    return state.initialMetadata.enums.message_types ?? []
  },
  getMessageTextsMetadata(state) {
    return state.initialMetadata.models.message_texts ?? []
  },
  getVariablesMetadata(state) {
    return state.initialMetadata.enums.variables ?? []
  },
  getAvailableFilterMessage(state) {
    return state.initialMetadata?.enums?.filter_columns_message_text ?? []
  },
  getAvailableFilterModelNotifications(state) {
    return state.initialMetadata?.enums?.filter_model_notifications ?? []
  },
  /*
        DOSSIER
   */
  getAvailableFilterDossier(state) {
    return state.initialMetadata?.enums?.filter_columns_dossier ?? []
  },
  /*
      DOCUMENT
 */
  getDocumentEmailRecipientMode(state) {
    return state.initialMetadata?.enums?.document.email_recipient_modes ?? []
  },
  /*
          AGENDA
     */
  getEventTypesList(state) {
    return state.initialMetadata?.enums?.event_type_list ?? []
  },
  getAvailableFilterAgenda(state) {
    return state.initialMetadata?.enums?.filter_agenda ?? []
  },
  getThemeColors(state) {
    return state.initialMetadata.enums.theme_colors ?? []
  },
  /*
          PLANNING
     */
  getAvailableFilterPlanning(state) {
    return state.initialMetadata?.enums?.filter_planning ?? []
  },

  /*
           SUPPLIER_ORDER
     */
  getAvailableFilterSupplierOrder(state) {
    return state.initialMetadata?.enums?.filter_supplier_order ?? []
  },

  /*
           TASK
     */
  getAvailableFilterTask(state) {
    return state.initialMetadata?.enums?.filter_task ?? []
  },
  getAvailableFilterTaskDossier(state) {
    return state.initialMetadata?.enums?.filter_task_dossier ?? []
  },
  getTaskDossierColumns(state) {
    return state.initialMetadata?.enums?.task_dossier_columns ?? []
  },
  getTaskDueDateTypes(state) {
    return state.initialMetadata?.enums?.task_due_date_types ?? []
  },
  getDueDateTypesTaskDossier(state) {
    return state.initialMetadata?.enums?.due_date_types ?? []
  },

  /*
          INVOICING
     */
  // Every document type, including COMNOTE: only the accounting journals need it
  getAllInvoiceDocTypes(state) {
    return state.initialMetadata?.enums?.invoicing_doc_types ?? []
  },
  // COMNOTE (commission note) is not a document users create or pick elsewhere
  getInvoiceDocTypes(state) {
    return (state.initialMetadata?.enums?.invoicing_doc_types ?? []).filter(
      (docType) => docType.id !== DocTypes.COMMISSION_NOTE
    )
  },
  getInvoiceDocRoles(state) {
    return state.initialMetadata?.enums?.invoicing_doc_roles ?? []
  },
  getAvailableInvoiceDossier(state) {
    return state.initialMetadata?.enums?.filter_columns_invoicing ?? []
  },
  getAvailableFilterPayment(state) {
    return state.initialMetadata?.enums?.filter_columns_payment ?? []
  },
  getAvailableFilterCommissionNote(state) {
    return state.initialMetadata?.enums?.filter_columns_commission_note ?? []
  },
  getColumnTypesCommissionNoteDashboard(state) {
    return state.initialMetadata?.enums?.column_commission_note_types ?? []
  },
  getColumnTypesInvoicingDashboard(state) {
    return state.initialMetadata?.enums?.invoicing.dashboard.column_types ?? []
  },
  getColumnTypesPaymentDashboard(state) {
    return state.initialMetadata?.enums?.column_payment_types ?? []
  },
  getColumnTypesThirdPartyCostDashboard(state) {
    return state.initialMetadata?.enums?.third_party_cost_column_types ?? []
  },
  getAvailableFilterThirdPartyCost(state) {
    return state.initialMetadata?.enums?.filter_columns_third_party_cost ?? []
  },
  getAvailableFilterInvoiceItem(state) {
    return state.initialMetadata?.enums?.filter_columns_invoice_item ?? []
  },
  getChiftSendingOptions(state) {
    return state.initialMetadata?.enums?.invoicing.chift.sending_options ?? []
  },
  getPaymentStatusesMetadata(state) {
    return state.initialMetadata.enums.payment_statuses ?? []
  },
  getFiscalCategoriesMetadata(state) {
    return state.initialMetadata.enums.fiscal_categories ?? []
  },
  getPaymentOriginsMetadata(state) {
    return state.initialMetadata.enums.payment_origins ?? []
  },
  getMetadataInvoiceStatus(state) {
    return state.initialMetadata.enums.invoice_status ?? []
  },
  getMetadataInvoiceStatusTags(state) {
    return state.initialMetadata.models.invoice_status_tags ?? []
  },
  getPaymentTypesMetadata(state) {
    return state.initialMetadata.enums.payment_types ?? []
  },
  getPaymentModesMetadata(state) {
    return state.initialMetadata.enums.payment_modes ?? []
  },
  getInvoicingPdfHeaderOptions(state) {
    return state.initialMetadata.enums.invoicing_pdf_header_options ?? []
  },
  getTenantModuleBillingTypesMetadata(state) {
    return state.initialMetadata.enums.tenant_module_billing_types ?? []
  },
  // getMessageGroupsMetadata(state) {
  //   return state.initialMetadata.enums.message_groups ?? []
  // },
  getSelectedVatRatesInSettingsMetadata(state) {
    return state.initialMetadata.settings.vat_rates ?? []
  },
  getDefaultCurrencyMetadata(state) {
    return state.initialMetadata.settings.default_currency ?? 'EUR'
  },
  getVatRatesMetadata(state) {
    return state.initialMetadata.enums.vat_rates ?? []
  },
  getBankAccountsMetadata(state) {
    return state.initialMetadata.models.bankAccounts ?? []
  },
  getCheckDepositStatusesMetadata(state) {
    return state.initialMetadata.enums.check_deposit_status ?? []
  },
  getScheduledTaskActionsMetadata(state) {
    return state.initialMetadata.enums.scheduled_task_actions ?? []
  },
  getScheduledTaskFrequenciesMetadata(state) {
    return state.initialMetadata.enums.scheduled_task_frequencies ?? []
  },
  getCloseSupplierOrdersConditionAttributesMetadata(state) {
    return (
      state.initialMetadata.enums.close_supplier_orders_condition_attributes ??
      []
    )
  },
  getAutomationConditionOperatorsMetadata(state) {
    return state.initialMetadata.enums.automation_condition_operators ?? []
  },
  /*
        DOCUMENTS
   */
  getHeaderDocTypes(state) {
    return state.initialMetadata?.enums?.header_doc_types ?? []
  },
  getDocumentCategoriesMetadata(state) {
    return state.initialMetadata.models?.list_items?.document_categories ?? []
  },
  /*
        DASHBOARD
   */
  getTemplateDashboards(state) {
    return state.initialMetadata?.models?.template_dashboards ?? []
  },
  getTemplateDashboardTypes(state) {
    return state.initialMetadata?.enums?.template_dashboard_types ?? []
  },
  getDashboardCreationTypes(state) {
    return state.initialMetadata?.enums?.dashboard_creation_types ?? []
  },
  getTemplateDashboardByType: (state) => (type) => {
    return (
      state.initialMetadata?.models?.template_dashboards
        ?.filter((item) => item.type === type)
        ?.sort((a, b) => {
          const posA = a.pivot?.local_position ?? null
          const posB = b.pivot?.local_position ?? null
          if (posA === null || posB === null) {
            return posA === null ? 1 : -1
          }
          return posA - posB
        }) ?? []
    )
  },
  /*
        STATISTICS
   */
  getAvailableFilterAnalytics(state) {
    return state.initialMetadata?.enums?.filter_analytics ?? []
  },
  getFilterAnalyticsSalesTurnover(state) {
    return state.initialMetadata?.enums?.filter_analytics_sales_turnover ?? []
  },
  getDashboardListStatistics(state) {
    return state.initialMetadata?.models?.analytics_dashboards ?? []
  },
  getStatsTypes(state) {
    return state.initialMetadata?.enums?.stats_types ?? []
  },
  getAnalyticsGroups(state) {
    return state.initialMetadata?.enums?.analytics?.groups ?? []
  },
  getChartTypes(state) {
    return state.initialMetadata?.enums?.chart_types ?? []
  },
  getStatsPeriods(state) {
    return state.initialMetadata?.enums?.analytics?.stats_periods ?? []
  },
  getRelativeDatesAnalytics(state) {
    return (
      state.initialMetadata?.enums?.analytics?.relative_dates_analytics ?? []
    )
  },
  getAnalyticsStackDossier(state) {
    return state.initialMetadata?.enums?.analytics?.stacks?.dossier ?? []
  },
  getAnalyticsStackInvoicing(state) {
    return state.initialMetadata?.enums?.analytics?.stacks?.invoicing ?? []
  },
  getAnalyticsStackEvent(state) {
    return state.initialMetadata?.enums?.analytics?.stacks?.event ?? []
  },
  getAnalyticsStackInvoiceItem(state) {
    return state.initialMetadata?.enums?.analytics?.stacks?.invoice_item ?? []
  },
  getAnalyticsSamples(state) {
    return state.initialMetadata?.enums?.analytics?.samples ?? []
  },
  /*
          EVENT
   */
  getEventStatusesMetadata(state) {
    return state.initialMetadata.enums.event_statuses ?? []
  },
  getEventVisitTypesMetadata(state) {
    return state.initialMetadata.enums.visite_types ?? []
  },
  getEventReunionTypesMetadata(state) {
    return state.initialMetadata.enums.reunion_types ?? []
  },
  /*
          OPENAI
   */
  getOpenAiEmailMessagesType(state) {
    return state.initialMetadata.enums?.openai?.email_messages_type ?? []
  },
  /*
          EMAIL
   */
  getEmailStateTypes(state) {
    return state.initialMetadata.enums?.email?.states ?? []
  },
  getEmailDirections(state) {
    return state.initialMetadata.enums?.email?.directions ?? []
  },
  /*
      SETTINGS
  */
  getOpenAIEnabled(state) {
    return state.initialMetadata?.settings?.openai_enabled ?? false
  },
  getMetadataPriceEncodingType(state) {
    return state.initialMetadata?.settings?.price_encoding_type
  },
  getInvoicingColumns(state) {
    return state.initialMetadata.settings.invoicing_columns
  },
  getThirdPartyColumns(state) {
    return state.initialMetadata.settings.third_party_cost_columns
  },
  getAvailableLanguages(state) {
    return state.initialMetadata.settings.available_languages
  },
  getDefaultLanguage(state) {
    return state.initialMetadata.settings.default_language
  },
  getDefaultCountry(state) {
    return state.initialMetadata.settings.default_country
  },
  getFhMenuOrder(state) {
    return state.initialMetadata.settings.fh_menu_order
  },
  getListColors(state) {
    return state.initialMetadata?.enums?.theme_colors ?? []
  },
  getEventsOrder(state) {
    return (
      state.initialMetadata?.settings?.events_order ?? {
        funeral: base_order_funeral,
        remain: base_order_remain
      }
    )
  },
  getInfosDossierOrder(state) {
    return (
      state.initialMetadata?.settings?.infos_dossier_order ?? {
        base_order_infos_dossier
      }
    )
  },
  /**
   * Returns the hidden section keys for a given page and funeral home.
   * Stored under form_settings[funeralHomeId].sections.[pageKey].
   *
   * @param {string} pageKey
   * @param {string} funeralHomeId
   * @returns {string[]}
   */
  getHiddenSections: (state) => (pageKey, funeralHomeId) => {
    if (funeralHomeId) {
      return (
        state.initialMetadata?.form_settings?.[funeralHomeId]?.sections?.[
          pageKey
        ] ?? []
      )
    }
    return []
  },
  /**
   * Returns the ordered array of event type codes for a given page.
   * The events_order setting uses 'funeral'/'remain' keys (singular) while
   * sectionPageKey uses 'funerals'/'remains' (plural), so we map them here.
   *
   * @param {'informations'|'funerals'|'remains'} pageKey
   * @returns {string[]}
   */
  getSectionsOrder: (state) => (pageKey) => {
    if (pageKey === 'informations') {
      return state.initialMetadata?.settings?.infos_dossier_order ?? []
    }
    const storageKeyMap = { funerals: 'funeral', remains: 'remain' }
    const storageKey = storageKeyMap[pageKey] ?? pageKey
    return state.initialMetadata?.settings?.events_order?.[storageKey] ?? []
  },
  getQuantityTypeResults(state) {
    return state.initialMetadata?.enums?.quantity_type_results ?? []
  },
  getDateRangeDefinition(state) {
    return state.initialMetadata?.enums?.quantity_date_range_definition ?? []
  },
  getQuantityDossierPropertyFields(state) {
    return state.initialMetadata?.enums?.quantity_dossier_property_fields ?? []
  },
  getDefaultUsersEventFunctions(state) {
    return state.initialMetadata?.enums?.default_users_event_functions ?? []
  },

  /*
        APP SETTINGS
   */

  getWebsocketSetting(state) {
    return state.initialMetadata?.app_settings?.websocket ?? null
  },
  getTenantIdSetting(state) {
    return state.initialMetadata?.app_settings?.tenant_id ?? null
  },
  getFunctionalities(state) {
    return state.initialMetadata?.app_settings?.functionalities ?? []
  },
  getReleaseVersion(state) {
    return state.initialMetadata?.app_settings?.release_version ?? null
  },
  getInstantSearchSetting(state) {
    return state.initialMetadata?.app_settings?.instant_search ?? false
  },

  /*
        ELECTRONIC SIGNATURE
   */

  getElectronicSignatureStatuses(state) {
    return state.initialMetadata?.enums?.electronic_signature?.statuses ?? []
  },
  getElectronicSignatureSignerStatus(state) {
    return (
      state.initialMetadata?.enums?.electronic_signature?.signer_statuses ?? []
    )
  },

  /*
        FORM EDITION
   */
  getGlobalFormCurrentFormSettings(state) {
    return state.global_form.current_form_settings
  },
  getGlobalFormFuneralHomeId(state) {
    return state.global_form.funeral_home_id
  },
  getGlobalFormEditionMode(state) {
    return state.global_form.edition_mode
  },
  /*
      FH SETTINGS
  */
  getFuneralHomeSettings(state) {
    return state.initialMetadata.fh_settings
  },
  /*
      SCREEN
  */
  getVideos(state) {
    return state.initialMetadata.enums.videos ?? []
  },
  getScreenConfigTypes(state) {
    return state.initialMetadata.enums.screen.types ?? []
  },
  getScreenTemplates(state) {
    return state.initialMetadata.enums.screen.templates ?? []
  },
  getScreenEmblems(state) {
    return state.initialMetadata.enums.screen.emblems ?? []
  },
  getScreenHardwareTypes(state) {
    return state.initialMetadata.enums.screen.hardware_types ?? []
  },
  /*
    IMPORT
  */
  getImportModes(state) {
    return state.initialMetadata.enums.import.import_mode ?? []
  },
  getImportPlateforms(state) {
    return state.initialMetadata.enums.import.import_plateform ?? []
  },
  /*
    WIKI
   */
  getWikiPlaceTypesList(state) {
    return state.initialMetadata?.enums?.wiki_place_types ?? []
  },
  getPlaceTypesList(state) {
    return state.initialMetadata?.enums?.place_types ?? []
  },
  /*
    RELEASE NOTES
   */
  getReleaseNoteTypes(state) {
    return state.initialMetadata?.enums?.release?.release_note?.types ?? []
  },
  getModelActivityTypes(state) {
    return state.initialMetadata?.enums?.model_activity_types ?? []
  },
  /*
    PARTNER
   */
  getLegacioDocTypes(state) {
    return state.initialMetadata?.enums?.legacio_doc_types ?? []
  },
  getLegacioNotifyRecipients(state) {
    return state.initialMetadata?.enums?.legacio_notify_recipients ?? []
  },
  getEnaosDocTypes(state) {
    return state.initialMetadata?.enums?.enaos_doc_types ?? []
  },
  getFuneUpDocTypes(state) {
    return state.initialMetadata?.enums?.funeup_doc_types ?? []
  },
  getEnaosSalesImportStrategies(state) {
    return state.initialMetadata?.enums?.enaos_sales_import_strategy ?? []
  },
  getEnaosSalesImportSchedules(state) {
    return state.initialMetadata?.enums?.enaos_sales_import_schedule ?? []
  },
  getEnaosVisitDateFormats(state) {
    return state.initialMetadata?.enums?.enaos_visit_date_format ?? []
  },

  getElysDossierStatuses(state) {
    return state.initialMetadata?.enums?.elys_dossier_statuses ?? []
  },
  getElysBezwaars(state) {
    return state.initialMetadata?.enums?.elys_bezwaars ?? []
  },
  getElysDocumentsTypes(state) {
    return state.initialMetadata?.enums?.elys_documents_types ?? []
  },
  getElysMaatregels(state) {
    return state.initialMetadata?.enums?.elys_maatregels ?? []
  },
  getElysRisicos(state) {
    return state.initialMetadata?.enums?.elys_risicos ?? []
  },
  getElysTransportToegelaten(state) {
    return state.initialMetadata?.enums?.elys_transport_toegelaten ?? []
  },
  getElysTransportVoorwaarden(state) {
    return state.initialMetadata?.enums?.elys_transport_voorwaarden ?? []
  },
  getElysActies(state) {
    return state.initialMetadata?.enums?.elys_acties ?? []
  },
  getElysRemainsDeliveries(state) {
    return state.initialMetadata?.enums?.elys_remains_deliveries ?? []
  },
  getElysRemainsDestinations(state) {
    return state.initialMetadata?.enums?.elys_remains_destinations ?? []
  },
  getElysConcessions(state) {
    return state.initialMetadata?.enums?.elys_concessions ?? []
  },
  getElysMemorialPlaques(state) {
    return state.initialMetadata?.enums?.elys_memorial_plaques ?? []
  },
  getElysReservationStatuses(state) {
    return state.initialMetadata?.enums?.elys_reservation_statuses ?? []
  },
  /*
    ACTIVITY LOG
   */
  getActivityLogTypes(state) {
    return state.initialMetadata?.enums?.activity_log?.types ?? []
  },
  /*
    WEBSITE
   */
  getFlowersOrderTypes(state) {
    return state.initialMetadata?.enums?.website.flowers_order_limit_types ?? []
  },
  getFlowersOrderDelays(state) {
    return (
      state.initialMetadata?.enums?.website.flowers_order_limit_delays ?? []
    )
  },
  /*
    PERSON
   */
  getPersonDocumentDeliveryPreferences(state) {
    return (
      state.initialMetadata?.enums?.person?.document_delivery_preferences ?? []
    )
  },
  getPersonCommunicationMethodePreferences(state) {
    return (
      state.initialMetadata?.enums?.person?.communication_methode_preferences ??
      []
    )
  },
  /*
   AUTH
  */
  getGuiPattern(state) {
    return state.initialMetadata?.enums?.gui_patterns ?? []
  },
  getGuiPatternIntensities(state) {
    return state.initialMetadata?.enums?.gui_pattern_intensities ?? []
  },
  getGuiThemes(state) {
    return state.initialMetadata?.enums?.gui_themes ?? []
  }
} satisfies MetadataGetters
